import { render, staticRenderFns } from "./tagSelecter.vue?vue&type=template&id=2ab5ac64&scoped=true"
import script from "./tagSelecter.vue?vue&type=script&lang=js"
export * from "./tagSelecter.vue?vue&type=script&lang=js"
import style0 from "./tagSelecter.vue?vue&type=style&index=0&id=2ab5ac64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5ac64",
  null
  
)

export default component.exports